<template>
  <ContactsListModal/>

  <!-- New Group -->
  <chat-group-modal></chat-group-modal>
  <!-- /New Group -->

  <!-- New Chat -->
  <div class="modal fade" id="Success-group">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content success-group-wrap-list">
        <div class="modal-header">
          <div class="success-pass mx-auto">
            <img
              src="@/assets/img/avatar/avatar-16.png"
              alt="Success"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="modal-body">
          <div class="success-header">
            <h4>Success</h4>
            <p>Group Created Successfully</p>
          </div>
          <a class="btn btn-primary" data-bs-dismiss="modal" :aria-label="$t('close')"> OK </a>
        </div>
      </div>
    </div>
  </div>
  <!-- /New Chat -->

  <!-- New Group -->
  <div class="modal fade" id="invite-other">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Invite Friends</h5>
          <button type="button" class="close" data-bs-dismiss="modal" :aria-label="$t('close')">
            <span class="material-icons">close</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="user-profiles-group mb-4">
            <div class="pass-login">
              <label class="form-label">Email Address or Phone Number</label>
              <input type="password" class="form-control pass-input" />
            </div>
            <div class="pass-login">
              <label class="form-label">Invitation Message </label>
              <textarea class="form-control"></textarea>
            </div>
          </div>
          <div class="mute-chat-btn">
            <a class="btn btn-secondary" data-bs-dismiss="modal" :aria-label="$t('close')">
              <i class="feather-x me-1"></i>Cancel
            </a>
            <a class="btn btn-primary" data-bs-dismiss="modal" :aria-label="$t('close')">
              <i class="bx bx-send me-1"></i>Send Invitation
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /New Group -->
</template>

<script>
import {mapGetters} from "vuex";
import ContactsListModal from "@/components/frontend/ContactsListModal";

export default {
  components: {ContactsListModal},
  data() {
    return {
    };
  },

  computed: {
    ...mapGetters({
      contacts: 'chat/contacts',
    }),

    filteredResults() {
      let results = {};
      this.contacts.forEach(e => {
        results[e.username[0]] = results[e.username[0]] ?? [];
        results[e.username[0]].push(e);
      });

      return results;
    },
  },
};
</script>
